import { Location } from '../types';

type LocationLike = Pick<Location, 'lat' | 'lng'>;

const isSameLocation = (first: Location, second: Location) =>
  first.lat === second.lat && first.lng === second.lng;

export const normalizeDeliveryAreaPath = (
  path: ReadonlyArray<LocationLike>
): Location[] => {
  const normalizedPath = path.map(({ lat, lng }) => {
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
      throw new Error('Delivery-area coordinates must be finite numbers.');
    }

    return { lat, lng };
  });

  if (
    normalizedPath.length > 1 &&
    isSameLocation(
      normalizedPath[0],
      normalizedPath[normalizedPath.length - 1]
    )
  ) {
    normalizedPath.pop();
  }

  return normalizedPath;
};

export const canFinishDeliveryArea = (path: ReadonlyArray<LocationLike>) =>
  new Set(
    normalizeDeliveryAreaPath(path).map(({ lat, lng }) => `${lat}:${lng}`)
  ).size >= 3;
